import React, { useEffect, useState, useContext, useRef, memo } from "react";

// Libraries
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { useScroll } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Accordion, Container, Navbar, Col } from "react-bootstrap";
import useOnClickOutside from "../../Functions/UseOnClickOutside";

// Component
import { Input } from '../Form/Form';
import Buttons from '../Button/Buttons';
import ReactCustomScrollbar from "../ReactCustomScrollbar";

// Context
import GlobalContext from "../../Context/Context";

// Data
import HeaderData from "./HeaderDataBus";
import { IMAGE_PATHS, DOMAIN_URL } from '../../Functions/Constant';

// css
import "../../Assets/scss/layouts/_header.scss"

/* Header Component Start */
export const Header = memo((props) => {
  const { setHeaderHeight } = useContext(GlobalContext);
  const { scrollY } = useScroll();
  const [scrollPos, setScrollPos] = useState({
    y: 0,
    prevY: -1,
    directionDown: true,
  });
  const location = useLocation();

  useEffect(() => {
    let headerEl = document.querySelector("header");

    function setTopSpace() {
      let windowWidth = window.innerWidth,
        headerheight = (props.topSpace.desktop && props.topSpace.desktop === true) ? headerEl.offsetHeight : 0;

      if (windowWidth <= 1199 && props.topSpace.lg) {
        headerheight = props.topSpace.lg === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 991 && props.topSpace.md) {
        headerheight = props.topSpace.md === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 767 && props.topSpace.sm) {
        headerheight = props.topSpace.sm === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 575 && props.topSpace.xs) {
        headerheight = props.topSpace.xs === true ? headerEl.offsetHeight : 0;
      }

      setHeaderHeight(headerheight);
    }

    setTopSpace();

    window.addEventListener("load", setTopSpace);
    window.addEventListener("resize", setTopSpace);

    if (document.body.classList.contains("mobile-menu")) {
      document.body.classList.remove("navbar-collapse-show");
      document.body.classList.remove("menu-modern");
      document.body.classList.remove("menu-full");
      document.body.style.removeProperty("overflow");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    let lastScrollTop = 0;
    scrollY.onChange((pos) => {
      if (pos > lastScrollTop) {
        setScrollPos({
          ...scrollPos,
          y: pos,
          prevY: pos - 1,
          directionDown: true,
        });
      } else {
        setScrollPos({
          ...scrollPos,
          y: pos,
          prevY: pos - 1,
          directionDown: false,
        });
      }

      if (pos === 0) {
        setScrollPos({ ...scrollPos, directionDown: true });
      }
      lastScrollTop = pos;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header
      className={`${props.className ? props.className : ""}${scrollPos.y > 5 ? " sticky-header shadow-md" : ""}${scrollPos.directionDown === false ? " header-appear shadow-md" : ""}${props.type ? ` ${props.type}` : ""}`}
    >
      {props.children}
    </header>
  );
});
/* Header Component End */

/* Headernav Component Start */
export const HeaderNav = (props) => {
  const handleMenuToggle = () => {
    let header = document.querySelector("header");
    if (!header) {
      console.warn("Header element not found in DOM");
      return;
    }
    let menu = header.querySelector(".navbar-nav"),
      menu_item = menu.querySelectorAll(".nav-item");

    if (!document.body.classList.contains("navbar-collapse-show")) {
      document.body.classList.add("navbar-collapse-show");
    } else {
      document.body.classList.remove("navbar-collapse-show");
    }

    menu_item.forEach(function (item) {
      if (item.classList.contains("open")) {
        setTimeout(() => {
          item.classList.remove("open");
        }, 200);
      }
    });
  };

  return (
    <Navbar
      collapseOnSelect
      id="headerbar"
      expand={props.expand}
      bg={props.bg ? props.bg : "transparent"}
      variant={props.theme}
      className={`${props.menu && `menu-${props.menu}`}${props.className ? ` ${props.className}` : ""}${props.bg || props.bg === "transparent" ? "" : " header-transparent"}`}
      onToggle={handleMenuToggle}
    >
      <Container
        fluid={props.fluid}
        className={props.containerClass ? props.containerClass : ""}
      >
        {props.children}
      </Container>
    </Navbar>
  );
};
/* Headernav Component End */

/* Topbar Component Start */
export const Topbar = ({ className, ...props }) => {
  useEffect(() => {
    let topbar = document.querySelector(".top-bar");
    if (typeof topbar != "undefined" && topbar != null) {
      let topbarHeight = `${topbar.clientHeight}px`;
      topbar.style.setProperty("--topbar-height", topbarHeight);
    }
  }, []);

  return (
    <div className={`top-bar${className ? ` ${className}` : ""}`} {...props}>
      {props.children}
    </div>
  );
};
/* Topbar Component End */

/* Menu Component Start */
export const Menu = memo((props) => {
  const megamenu_ref = useRef(null);
  const [isMenuActive, setMenuActive] = useState(null);
  const [isHover, setIsHover] = useState(false);
  const handleMenuClick = (e, index) => setMenuActive(index !== isMenuActive ? index : null);

  const location = useLocation();

  useEffect(() => {
    let header = document.querySelector("header"),
      navItem = header.querySelectorAll(".nav-item"),
      links = header.querySelectorAll(".nav-link");

    navItem.forEach(item => item.classList.remove("active"));

    const activeLink = Array.from(links).find(link => link.getAttribute("href") === location.pathname);
    if (activeLink) {
      import("../../Functions/Utilities").then(module => {
        let filtered_dropdown = module.getParents(activeLink).filter(item => item.classList.contains('simple-dropdown'));
        let filtered_nav_item = module.getParents(activeLink).filter(item => item.classList.contains('nav-item'));
        filtered_dropdown.forEach(item => item.classList.add("active"));
        filtered_nav_item.forEach(item => item.classList.add("active"));
      });
    }
  }, [location, isHover]);

  useEffect(() => {
    let navItems = document.querySelector("header").querySelectorAll(".navbar-nav > .nav-item");
    navItems.forEach(nav => nav.addEventListener("mouseover", () => setIsHover(true)));
  }, []);

  return (
    <div className={`${props.mobileMenu ? `mobile-menu-${props.mobileMenu}` : ""}${props.className ? ` ${props.className}` : ""}`}>
      <ul className="navbar-nav">
        {props.data.map((item, i) => {
          return (
            <li className={`nav-item${item.dropdown || item.megamenu ? ` dropdown` : ""}${isMenuActive === i ? " open" : ""}`} key={i}>
              {
                item.link ? (
                  <Link className="nav-link" to={item.link}>
                    {item.title}
                  </Link>
                ) : (
                  <span className="nav-link">{item.title}</span>
                )
              }
              <i className="fa fa-angle-down" onClick={(e) => handleMenuClick(e, i)} />
              {(item.dropdown) && (
                <ul className="simple-dropdown-menu">
                  {item.dropdown.map((item, i) => {
                    return (
                      <li key={i} className="simple-dropdown">
                        {
                          item.link ? (
                            <Link className="nav-link" to={item.link}>
                              {item.title}
                              {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                            </Link>
                          ) : (
                            <span className="nav-link">
                              {item.title}
                              {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                            </span>
                          )
                        }
                        {item.dropdown && (
                          <ul className="simple-dropdown-menu">
                            {item.dropdown.map((item, i) => {
                              return (
                                <li key={i} className="simple-dropdown">
                                  {
                                    item.link ? (
                                      <Link
                                        className={`nav-link${item.dropdown ? " md:text-black md:mt-[15px] md:mb-[7px]" : ""}`}
                                        to={item.link}
                                      >
                                        {item.title}
                                        {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                                      </Link>
                                    ) : (
                                      <span className="nav-link">
                                        {item.title}
                                        {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                                      </span>
                                    )
                                  }
                                  {item.dropdown && (
                                    <ul className="simple-dropdown-menu">
                                      {item.dropdown.map((item, i) => {
                                        return (
                                          <li
                                            className="simple-dropdown"
                                            key={i}
                                          >
                                            <Link className="nav-link" to={item.link}>{item.title}</Link>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
              {(item.megamenu) && (
                <div className="flex megamenu" ref={megamenu_ref}>
                  {item.megamenu.map((item, i) => {
                    return (
                      <ul className={`${(item.dropdown.filter(item => item.img).length > 0) ? "!pr-[30px] img-wrapper inline-block last:!pr-[0px]" : "inline-block"}`} key={i}>
                        {item.title && <li className="title text-md font-medium mb-[15px] whitespace-nowrap">
                          {item.title}
                        </li>}
                        {item.dropdown &&
                          item.dropdown.map((item, i) => {
                            return (
                              <li className="nav-item" key={i}>
                                {item.title && <Link className="nav-link" to={item.link ? item.link : "#"} > {item.icon && (<i className={`${item.icon} mr-[10px]`} ></i>)}{" "}
                                  {item.title}
                                </Link>}
                                {(item.img && item.link) && <Link to={item.link}><img crossorigin="anonymous" height="235" alt="menu-banner" width="210" className="inline-block max-w-[210px]" src={item.img} /></Link>}
                              </li>
                            );
                          })}
                      </ul>
                    );
                  })}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
});
/* Menu Component End */

/* Mobile Menu Component Start */
export const MobileMenu = memo(({ className = "", type = "full", userData, onLogout, data = [], isDisabled = false, ...props }) => {
  const megamenu_ref = useRef(null);
  const [isMenuActive, setMenuActive] = useState(null);
  const [toggle, setToggle] = useState(false);
  const location = useLocation();

  const handleMenuClick = (e, index) => setMenuActive(index !== isMenuActive ? index : null);

  useEffect(() => {
    let header = document.querySelector("header"),
      links = header?.querySelectorAll(".nav-link") || [];

    function getParents(elem) {
      var parents = [];
      while (elem.parentNode && elem.parentNode.nodeName.toLowerCase() !== "body") {
        elem = elem.parentNode;
        parents.push(elem);
      }
      return parents;
    }

    links.forEach((item) => {
      let attr = item.getAttribute("href");
      item.classList.remove("active");
      if (attr === location.pathname) {
        if (item.closest(".simple-dropdown")) {
          item.closest(".simple-dropdown").querySelectorAll(".nav-link").forEach((item) => item.classList.remove("active"));
        }
        item.classList.add("active");

        let filtered_dropdown = getParents(item).filter((item) => item.classList.contains("simple-dropdown"));
        let filtered_nav_item = getParents(item).filter((item) => item.classList.contains("nav-item"));
        filtered_dropdown.forEach((item) => item.classList.add("active"));
        filtered_nav_item.forEach((item) => item.classList.add("active"));
      }
    });
  }, [location]);

  useEffect(() => {
    document.body.classList.add("mobile-menu");
    const close = (e) => {
      if (e.keyCode === 27 && (document.body.classList.contains("menu-modern") || document.body.classList.contains("menu-full"))) {
        document.querySelector("#close-btn")?.click();
      }
    };

    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  useEffect(() => {
    const breakpoint = window.matchMedia("(max-width: 991px)");
    function breakpointCheck(x) {
      if (x.matches) {
        if (toggle) {
          document.body.style.overflow = "hidden";
          document.body.classList.add("mobile-menu", `menu-${type}`);
        } else {
          document.body.style.removeProperty("overflow");
          document.body.classList.remove(`menu-${type}`);
        }
      } else {
        document.body.style.removeProperty("overflow");
        document.body.classList.remove("mobile-menu", `menu-${type}`);
      }
    }

    breakpointCheck(breakpoint);
    breakpoint.addListener(breakpointCheck);
  }, [toggle, type]);

  return (
    <div className={className}>
      <Navbar.Toggle id="toggle-bar" className="order-last md:px-[25px] sm:ml-0" onClick={() => setToggle(!toggle)}>
        <span className="navbar-toggler-line"></span>
        <span className="navbar-toggler-line"></span>
        <span className="navbar-toggler-line"></span>
        <span className="navbar-toggler-line"></span>
      </Navbar.Toggle>
      <Navbar.Collapse id="myCollapsible" className={`col-auto justify-center mobile-menu-${type}`}>
        <Navbar.Toggle id="close-btn" onClick={() => setToggle(!toggle)}>
          <span className="navbar-toggler-line bg-white"></span>
          <span className="navbar-toggler-line bg-white"></span>
          <span className="navbar-toggler-line bg-white"></span>
          <span className="navbar-toggler-line bg-white"></span>
        </Navbar.Toggle>
        <ReactCustomScrollbar className="pr-[15px]" theme="light" autoHide>
          <div>
            <ul className="navbar-nav">
              {userData && (
                <>
                  <li className="nav-item">
                    <div className="flex items-center space-x-3">
                      {isDisabled ? (
                        <span className="text-gray-500 cursor-not-allowed opacity-50">
                          <img
                          crossorigin="anonymous"
                            src={userData?.profile_image || IMAGE_PATHS.USER}
                            alt="User"
                            className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
                          />
                        </span>
                      ) : (
                        <Link to="/verifications">
                          <img
                          crossorigin="anonymous"
                            src={userData?.profile_image || IMAGE_PATHS.USER}
                            alt="User"
                            className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
                          />
                        </Link>
                      )}
                      <div>
                        {isDisabled ? (
                          <>
                            <span className="text-gray-500 cursor-not-allowed opacity-50">
                              <p className="text-white font-semibold text-sm">{userData?.name || "User Name"}</p>
                            </span>
                            <span className="text-gray-500 cursor-not-allowed opacity-50">
                              <p className="text-white text-xs">{userData?.email || "No email available"}</p>
                            </span>
                          </>
                        ) : (
                          <>
                            <Link to="/verifications">
                              <p className="text-white font-semibold text-sm">{userData?.name || "User Name"}</p>
                            </Link>
                            <Link to="/verifications">
                              <p className="text-white text-xs">{userData?.email || "No email available"}</p>
                            </Link>
                          </>
                        )}
                      </div>
                    </div>
                  </li>
                  <li className="nav-item">
                    {isDisabled ? (
                      <span className="nav-link text-gray-500 cursor-not-allowed opacity-50">
                        Account Settings
                      </span>
                    ) : (
                      <Link className="nav-link" to="/account-settings">
                        Account Settings
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isDisabled ? (
                      <span className="nav-link text-gray-500 cursor-not-allowed opacity-50">
                        Business settings
                      </span>
                    ) : (
                      <Link className="nav-link" to="/business-settings">
                        Business settings
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isDisabled ? (
                      <span className="nav-link text-gray-500 cursor-not-allowed opacity-50">
                        Support
                      </span>
                    ) : (
                      <Link className="nav-link" to="/contact_us">
                        Support
                      </Link>
                    )}
                  </li>
                </>
              )}
              {!isDisabled && data.map((item, i) => {
                if (!item.title || !item.title.trim()) return null;

                return (
                  <li
                    className={`nav-item${item.dropdown || item.megamenu ? ` dropdown` : ""}${isMenuActive === i ? " open" : ""}`}
                    key={i}
                  >
                    {item.link ? (
                      <Link className="nav-link" to={item.link}>
                        {item.title}
                      </Link>
                    ) : (
                      <span className="nav-link">{item.title}</span>
                    )}
                    {item.dropdown && <i className="fa fa-angle-down" onClick={(e) => handleMenuClick(e, i)} />}
                    {item.dropdown && (
                      <ul className="simple-dropdown-menu">
                        {item.dropdown.map((subItem, j) => {
                          if (!subItem.title || !subItem.title.trim()) return null;

                          return (
                            <li key={j} className="simple-dropdown">
                              {subItem.link ? (
                                <Link className="nav-link" to={subItem.link}>
                                  {subItem.title}
                                  {subItem.dropdown && <i className="fas fa-angle-right"></i>}
                                </Link>
                              ) : (
                                <span className="nav-link">
                                  {subItem.title}
                                  {subItem.dropdown && <i className="fas fa-angle-right"></i>}
                                </span>
                              )}
                              {subItem.dropdown && (
                                <ul className="simple-dropdown-menu">
                                  {subItem.dropdown.map((nestedItem, k) => {
                                    if (!nestedItem.title || !nestedItem.title.trim()) return null;

                                    return (
                                      <li key={k} className="simple-dropdown">
                                        {nestedItem.link ? (
                                          <Link
                                            className={`nav-link${nestedItem.dropdown ? " md:text-black md:mt-[15px] md:mb-[7px]" : ""}`}
                                            to={nestedItem.link}
                                          >
                                            {nestedItem.title}
                                            {nestedItem.dropdown && <i className="fas fa-angle-right"></i>}
                                          </Link>
                                        ) : (
                                          <span className="nav-link">
                                            {nestedItem.title}
                                            {nestedItem.dropdown && <i className="fas fa-angle-right"></i>}
                                          </span>
                                        )}
                                        {nestedItem.dropdown && (
                                          <ul className="simple-dropdown-menu">
                                            {nestedItem.dropdown.map((deepNestedItem, l) => {
                                              if (!deepNestedItem.title || !deepNestedItem.title.trim()) return null;

                                              return (
                                                <li className="simple-dropdown" key={l}>
                                                  <Link className="nav-link" to={deepNestedItem.link}>
                                                    {deepNestedItem.title}
                                                  </Link>
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                    {item.megamenu && (
                      <div className="megamenu" ref={megamenu_ref}>
                        <div className="flex">
                          {item.megamenu.map((megaItem, m) => {
                            if (megaItem.title && (!megaItem.title || !megaItem.title.trim())) return null;

                            return (
                              <ul
                                key={m}
                                className={`${megaItem.dropdown.filter((subItem) => subItem.img).length > 0 ? "img-wrapper" : "inline-block"}`}
                              >
                                {megaItem.title && (
                                  <li className="title text-md font-medium mb-[10px] whitespace-nowrap">{megaItem.title}</li>
                                )}
                                {megaItem.dropdown &&
                                  megaItem.dropdown.map((subItem, n) => {
                                    if (subItem.title && (!subItem.title || !subItem.title.trim())) return null;

                                    return (
                                      <li className="nav-item" key={n}>
                                        {subItem.title && (
                                          <Link className="nav-link" to={subItem.link ? subItem.link : "#"}>
                                            {subItem.icon && <i className={`${subItem.icon} mr-[10px]`}></i>} {subItem.title}
                                          </Link>
                                        )}
                                        {subItem.img && subItem.link && (
                                          <Link to={subItem.link}>
                                            <img
                                            crossorigin="anonymous"
                                              height="235"
                                              alt="menu-banner"
                                              width="210"
                                              className="inline-block max-w-[210px]"
                                              src={subItem.img}
                                            />
                                          </Link>
                                        )}
                                      </li>
                                    );
                                  })}
                              </ul>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </li>
                );
              })}
              {userData && (
                <li className="nav-item">
                  <span className="nav-link" onClick={onLogout}>
                    Logout
                  </span>
                </li>
              )}
            </ul>
          </div>
        </ReactCustomScrollbar>
      </Navbar.Collapse>
    </div>
  );
});
/* Mobile Menu Component End */

/* HamburgerMenu Component Start */
export const HamburgerMenu = memo((props) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useOnClickOutside(ref, (e) => setShow(false));

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setShow(false);
      }
    };

    if (show === true) {
      document.querySelector("body").classList.add("overflow-hidden");
      document.querySelector(".push-button").classList.remove("collapsed");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
      document.querySelector(".push-button").classList.add("collapsed");
    }

    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [show]);

  return (
    <>
      {[false].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className={`header-push-button bg-transparent inline-block ${props.theme}`}
        >
          <Navbar.Toggle className={`push-button`} onClick={() => setShow(true)}>
            <div className="nav-icon">
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
            </div>
          </Navbar.Toggle>
          <div className={`${show ? "block h-[100vh] left-0 overflow-hidden fixed top-0 w-full z-[999]" : ""}`}>
            <div
              ref={ref} className={`hamburger-menu-wrapper pos-${props.position}${show ? " show" : ""}${props.className ? ` ${props.className}` : ""}`}
            >
              {props.closeBtn && (
                <button aria-label="hamburger menu close button" className="close-btn" onClick={() => setShow(false)}>
                  <i className="fas fa-times"></i>
                </button>
              )}
              {show && props.children}
            </div>
          </div>
        </Navbar>
      ))}
    </>
  );
});
/* HamburgerMenu Component End */

/* SearchBar Component Start */
export const SearchBar = memo(({ className, style, isDisabled = false }) => {
  const { setIsModalOpen } = useContext(GlobalContext);
  const ref = useRef(null);
  const [isSearchModalOpen, setSearchModalOpen] = useState(false);
  const navigate = useNavigate();
  useOnClickOutside(ref, () => setSearchModalOpen(false));
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Name");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (isSearchModalOpen === true) {
      setIsModalOpen(true);
    }
    if (isSearchModalOpen === false) {
      setIsModalOpen(false);
    }
  }, [isSearchModalOpen, setIsModalOpen]);

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setSearchModalOpen(false);
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  const handleSearch = () => {
    if (searchQuery.trim()) {
      let categoryValue = selectedCategory.toLowerCase();
      if (selectedCategory === "School/College") {
        categoryValue = "school";
      }
      navigate(`/search-employee?query=${encodeURIComponent(searchQuery)}&category=${encodeURIComponent(categoryValue)}`);
      setSearchModalOpen(false);
      setSearchQuery('');
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 27);
      setShowDropdown(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showDropdown]);

  return (
    <div
      className={`header-search-iconbar inline-block align-middle pl-[17px] text-[17px] leading-none${className ? ` ${className}` : ""}${isDisabled ? " opacity-50 cursor-not-allowed" : ""}`}
      style={style}
    >
      <Link
        to="#"
        aria-label="search"
        className="search-form-icon leading-[20px]"
        onClick={(e) => {
          e.preventDefault();
          if (!isDisabled) setSearchModalOpen(true);
        }}
      >
        <i
          className={`feather-search px-0 inline-block${className ? ` ${className}` : ""}${isDisabled ? " text-gray-500" : ""}`}
        ></i>
      </Link>
      <div className={`form-wrapper ${isSearchModalOpen ? " show" : ""}`}>
        <button
          title="Close"
          type="button"
          className="search-close font-serif"
          onClick={() => setSearchModalOpen(false)}
        >
          ×
        </button>
        {isSearchModalOpen && (
          <Col xs={12} md={12} className="justify-end pe-0 flex items-center xs:!w-[100%] !pl-0 search-form">
            <div className="w-[70%] shadow-md flex rounded-full shadowla bg-white relative overflow-visible leading-[2.2]">
              <div className="flex-1 relative">
                <input
                  type="text"
                  placeholder="Search To Review"
                  value={searchQuery}
                  onChange={(e) => !isDisabled && setSearchQuery(e.target.value)}
                  onKeyDown={isDisabled ? undefined : handleKeyPress}
                  className={`w-full pl-[3.5rem] pr-4 py-2 text-sm text-gray-700 placeholder-gray-400 rounded-l-full custom-placeholder !pt-[9px] ${isDisabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  disabled={isDisabled}
                />
                <div className="absolute inset-y-0 left-[1.5rem] flex items-center pointer-events-none">
                  <svg
                    viewBox="0 0 24 24"
                    width="20px"
                    height="20px"
                    className="text-gray-400"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.12 4.14a5.99 5.99 0 1 0 0 11.98 5.99 5.99 0 0 0 0-11.98m-7.49 5.99a7.49 7.49 0 1 1 13.299 4.728L21.37 20.3l-1.06 1.061-5.44-5.44A7.49 7.49 0 0 1 2.63 10.13"
                    />
                  </svg>
                </div>
              </div>
              <hr className="h-[24px] border border-[#caccd4] relative top-[5px]" />
              <div
                className={`relative flex items-center justify-between px-4 py-2 rounded-r-full xs:w-[40%] ${isDisabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                onClick={() => !isDisabled && setShowDropdown(!showDropdown)}
                ref={dropdownRef}
              >
                <span className="text-[13px] font-medium text-[#757575]">{selectedCategory}</span>
                <svg
                  className="w-4 h-4 ml-2 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
                {showDropdown && (
                  <ul className="absolute top-full right-0 mt-2 w-60 bg-white border border-gray-200 shadow-xl rounded-xl text-sm z-[9999] py-2">
                    {["Name", "Contact", "Company", "School/College", "Location"].map((item) => (
                      <li
                        key={item}
                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${item === selectedCategory ? "font-semibold text-gray-600" : ""}`}
                        onClick={() => {
                          setSelectedCategory(item);
                          setShowDropdown(false);
                        }}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </Col>
        )}
      </div>
    </div>
  );
});
/* SearchBar Component End */

Header.defaultProps = {
  topSpace: {
    desktop: false,
  },
};

Header.propTypes = {
  type: PropTypes.string,
  topSpace: PropTypes.object,
};

HeaderNav.defaultProps = {
  fluid: "lg",
  theme: "dark",
  menu: "light",
  expand: "lg",
};

HeaderNav.propTypes = {
  fluid: PropTypes.string,
  theme: PropTypes.string,
  bg: PropTypes.string,
  className: PropTypes.string,
};

HamburgerMenu.defaultProps = {
  theme: "light",
  position: "right",
  closeBtn: true,
};

HamburgerMenu.propTypes = {
  theme: PropTypes.string,
  position: PropTypes.string,
  closeBtn: PropTypes.bool,
};

Menu.defaultProps = {
  data: HeaderData(localStorage.getItem("jwt_token_jobcritic")),
};

MobileMenu.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  userData: PropTypes.object,
  onLogout: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.object),
  isDisabled: PropTypes.bool,
};

MobileMenu.defaultProps = {
  type: "full",
  className: "",
  userData: null,
  onLogout: null,
  data: [],
  isDisabled: false,
};

SearchBar.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
};

SearchBar.defaultProps = {
  className: "",
  style: {},
  isDisabled: false,
};

export default Header;